import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import breakpoints from "@app/scripts/breakpoints.json";


class StaffCard {
	constructor() {
		this.cards = gsap.utils.toArray(".card-staff");
		this.isMobile = window.matchMedia(`(max-width: ${breakpoints.s.breakpoint}px)`).matches

		if(!this.cards.length || !this.isMobile) return;

		this._toggleInView();
	}

	_toggleInView() {
		gsap.registerPlugin(ScrollTrigger);

    return ScrollTrigger.batch(this.cards, {
			start: "top 50%",
			end: "bottom 50%",
			toggleClass: "in-view",
			trigger: this.cards,
		});
  }
}

new StaffCard();
